import React, { useState } from "react";
import { Alert, Button, Checkbox, Modal } from "antd";

const CreateWorkOrder = ({ isModalVisible, handleCancel, handleOk, data }) => {
  const [isAllSelected, setIsAllSelected] = useState(false);

  const filteredData = data.map((item) => ({
    ...item,
    items: item.items.filter((subItem) => subItem.isFollowUp),
  }));

  const handleSelectAll = () => {
    setIsAllSelected(true);
    filteredData.forEach((item) => {
      item.items.forEach((subItem) => {
        subItem.isFollowUp = true;
      });
    });
  };

  const handleDeselectAll = () => {
    setIsAllSelected(false);
    filteredData.forEach((item) => {
      item.items.forEach((subItem) => {
        if (subItem.isFollowUp) {
          subItem.isFollowUp = false;
        }
      });
    });
  };

  const handleCheckboxChange = (itemKey) => {
    const newData = [...filteredData];
    let allChecked = true;

    newData.forEach((item) => {
      item.items.forEach((subItem) => {
        if (subItem.key === itemKey) {
          subItem.isFollowUp = !subItem.isFollowUp;
        }

        if (!subItem.isFollowUp) {
          allChecked = false;
        }
      });
    });

    setIsAllSelected(allChecked);
  };
  const hasFollowUp = data.some((parent) => {
    return parent.items.some((child) => child.isFollowUp);
  });
  console.log(hasFollowUp);

  return (
    <div>
      <Modal
        title="Create Work Order"
        open={isModalVisible}
        onCancel={handleCancel}
        onOk={handleOk}
        centered
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              {hasFollowUp && <Button onClick={handleOk} type="primary">Save</Button>}
              <Button onClick={handleCancel}>Cancel</Button>
            </div>
            <div></div>
          </div>
        }
      >
        {hasFollowUp && (
          <>
            <p>
              Please choose which flagged items should be added to this work
              order:
            </p>
            <div style={{ marginBottom: 16 }}>
              <Checkbox
                onChange={(e) =>
                  e.target.checked ? handleSelectAll() : handleDeselectAll()
                }
                checked={isAllSelected}
              >
                Select All
              </Checkbox>
            </div>
          </>
        )}
        {hasFollowUp ? (
          filteredData.map((item) =>
            item.items.map((child) =>
              child.isFollowUp ? (
                <>
                  <br />
                  <Checkbox
                    checked={child.isFollowUp}
                    onChange={() => handleCheckboxChange(child.key)}
                  >
                    {item.itemCardTitle}{" "}
                    <i className="fa-solid fa-arrow-right"></i>{" "}
                    {child.itemTitle}{" "}
                  </Checkbox>
                </>
              ) : null
            )
          )
        ) : (
          <>
            <Alert
              message='Flag an item as "Needs Work" first in order to create a work order.'
              type="warning"
              showIcon
            />
            <br />
            <p>
              Please choose which flagged items should be added to this work
              order:
            </p>
            <br />
            <p>No items flagged</p>
          </>
        )}
      </Modal>
    </div>
  );
};

export default CreateWorkOrder;
